import * as React from "react";
const SvgFiRrMosque = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mosque_svg__a)">
      <path
        fill="#062147"
        d="M22.528 13.433C23.471 12.296 24 11.012 24 9.736c0-3.696-3.118-5.393-5.395-6.631C17.324 2.408 16 1.687 16 1.001a1 1 0 1 0-2 0c0 .686-1.324 1.407-2.605 2.104-1.091.594-2.373 1.296-3.415 2.27C7.873 3.502 6.565 1.76 5.449.612c-.768-.791-2.129-.791-2.896 0C1.388 1.809 0 3.65 0 5.615V20c0 2.206 1.794 4 4 4h7a1 1 0 0 0 1-1v-3c0-.551.448-1 1-1 .579 0 1 .469 1 1.115V23a1 1 0 1 0 2 0v-3a1.001 1.001 0 0 1 2 0v3a1 1 0 0 0 1 1h1c2.206 0 4-1.794 4-4v-4a2.99 2.99 0 0 0-1.472-2.567M12.351 4.861c.965-.525 1.947-1.06 2.649-1.733.702.673 1.685 1.208 2.649 1.733C19.788 6.025 22 7.228 22 9.736c0 1.112-.677 2.287-1.858 3.265H9.862C8.694 12.02 8 10.819 8 9.736c0-2.508 2.212-3.711 4.351-4.875M4.013 2.003C5.276 3.303 6 4.619 6 5.614v1.385H2V5.614c0-.995.725-2.311 2.013-3.611M6 22H4c-1.103 0-2-.897-2-2V9h4zm16-2c0 1.103-.897 2-2 2v-2c0-1.654-1.346-3-3-3-.771 0-1.474.292-2.005.77A2.94 2.94 0 0 0 13 17c-1.654 0-3 1.346-3 3v2H8v-7h13c.552 0 1 .449 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mosque_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMosque;
